import type { MarketApps, MarketAppWithTabs, TileBigNumber } from '@/features/Dashboard/types';

type BuildTabsStructureParams = {
  sanitizedDraftTabs: string[];
  tabSourceNames: (string | null)[];
  normalizedCurrentTabName?: string | null;
  baseTabs?: Record<string, MarketApps> | null;
  currentTabPayload: MarketApps;
};

export const buildCurrentTabPayload = (
  tiles: TileBigNumber[],
  marketTabApps: MarketAppWithTabs[]
): MarketApps => {
  return [
    ...(tiles.length > 0
      ? [
          {
            type: 'tiles' as const,
            tiles,
            name: 'Tiles',
            metadata: {},
            layout: null,
            id: 'tiles'
          }
        ]
      : []),
    ...marketTabApps
  ];
};

export const buildTabsStructure = ({
  sanitizedDraftTabs,
  tabSourceNames,
  normalizedCurrentTabName,
  baseTabs = {},
  currentTabPayload
}: BuildTabsStructureParams): Record<string, MarketApps> => {
  const safeBaseTabs = baseTabs ?? {};
  const tabsStructure: Record<string, MarketApps> = {};

  sanitizedDraftTabs.forEach((tabName, index) => {
    const sourceName = tabSourceNames[index];
    let tabData: MarketApps | undefined;

    if (tabName === normalizedCurrentTabName) {
      tabData = currentTabPayload;
    } else if (sourceName && safeBaseTabs[sourceName]) {
      tabData = safeBaseTabs[sourceName];
    } else if (!sourceName && safeBaseTabs[tabName]) {
      tabData = safeBaseTabs[tabName];
    }

    tabsStructure[tabName] = tabData ?? [];
  });

  return tabsStructure;
};
